export const getGoogleMapLink = (venue) => {
	const venueAsString = Object.values(venue).join(',')
	const urlEncodedAddress = encodeURI(venueAsString);
	return `https://www.google.com/maps/search/?api=1&query=${urlEncodedAddress}`;
}
